import moment from "moment";
import { getPmSessionMonthRangeStrings } from "helpers/pmSessionDateHelper";
import { getCptAnalyticsTimezone } from "../../common/cptAnalyticsTimezone";

export const MONTH_OPTIONS = moment.months().map((label, index) => ({
  label,
  value: String(index + 1).padStart(2, "0")
}));

export const YEAR_OPTIONS = Array.from({ length: 6 }, (_, idx) =>
  String(moment().year() - idx)
);

export const PERFORMANCE_TYPE_OPTIONS = [
  { label: "All Patients", value: "all" },
  { label: "Met Both Components", value: "metBoth" },
  { label: "Met Only One Component", value: "metOnlyOne" },
  { label: "Met None", value: "metNone" }
];

export const getMonthRange = (year, month) => getPmSessionMonthRangeStrings(year, month);

export const getDefaultFilter = () => {
  const base = moment();
  const compared = moment().subtract(1, "month");
  return {
    baseMonth: base.format("MM"),
    baseYear: base.format("YYYY"),
    comparedMonth: compared.format("MM"),
    comparedYear: compared.format("YYYY"),
    performanceType: "all"
  };
};

export const formatMonthLabel = (year, month) =>
  moment(`${year}-${month}-01`).format("MMMM YYYY");

export const getUserTimezone = getCptAnalyticsTimezone;

export const csvEscape = (value) => {
  if (value === null || value === undefined) {
    return "";
  }

  const stringValue = String(value);
  if (/[",\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, "\"\"")}"`;
  }
  return stringValue;
};

export const downloadCsv = (filename, rows) => {
  const blob = new Blob([rows], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
